import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import {  cargarCatalogosGenericoAsync,cargarCatalogos_Otros, cargarCatalogosAsync } from '../../funciones_globales/catalogos';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
// import global_axios  from '../../funciones_globales/interaccionapi';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';


class FormVen24  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            cliente_sel: null,
            vendedor_sel:null,
            vendedores:[],
            marca_sel:null,
            fechaDesde: null,
            fechaHasta: null,
            pedidoMovil:'',
            resumido:false,
           
        };
        this.impRptArticulosNoDespachados = this.impRptArticulosNoDespachados.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);

    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
    
        this.setState({
          [name]: value
        });
    }

    getOptions_Clientes(input, callback){
        if (input.toString().length >= 4 ){
          let query = "?tipo=catalogo&cadena_busq=" + input;
          cargarCatalogosGenericoAsync('/clientes', query, callback);
        }
    }

    getOptions_Marcas(input, callback){
        if (input.toString().length >= 2 ){
          cargarCatalogosAsync('LINEA', input, callback)
        }
      }
    componentDidMount(){
        Promise.all([
            cargarCatalogos_Otros('GEN-VENDEDORES-REPO'),
            this.props.generar_LogAuditoriaIngresoForm('0424')
         ])
        .then(([vendedores ]) => { 
            let fechaHasta = moment(this.props.fechaProceso, "DD/MM/YYYY");
            let fechaDesde = fechaHasta.subtract(31, 'days');
         
            this.setState({vendedores,
                fechaDesde,
                fechaHasta: moment(this.props.fechaProceso, "DD/MM/YYYY") });
        })
     
        .catch(error=>{
            alert(error);
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0424');
    }

    impRptArticulosNoDespachados(){
        let fechaDesde = formatearFechaMoment_a_String(this.state.fechaDesde);
        if (!validarFechaMomentEnFormatoString(fechaDesde)){
            alert('La fecha Desde es inválida.');
            return;
        }
        
        let fechaHasta = formatearFechaMoment_a_String(this.state.fechaHasta);
        if (!validarFechaMomentEnFormatoString(fechaHasta)){
            alert('La fecha Hasta es inválida.');
            return;
        }

        if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0){        
            alert(`La fecha Desde debe ser menor a: ${formatearFechaMoment_a_String(this.state.fechaHasta)}`);
            return;
        }
        let urlRpt = '&rpt=108&param1='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)
                        +'&param2='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta);

        if(this.state.cliente_sel!==null){
                urlRpt += '&param3='+this.state.cliente_sel.value;
        }
        if(this.state.vendedor_sel!==null){
            urlRpt += '&param4='+this.state.vendedor_sel.value;
        }
        if(this.state.marca_sel!==null){
            urlRpt += '&param5='+this.state.marca_sel.value;
        }
        if(this.state.pedidoMovil!==null && this.state.pedidoMovil!==''){
            urlRpt += '&param6='+this.state.pedidoMovil;
        }
        visualizarReporteEnPdf(urlRpt);
       
    }
    limpiar(){        
        let fechaHasta = moment(this.props.fechaProceso, "DD/MM/YYYY");
        let fechaDesde = fechaHasta.subtract(31, 'days');
        this.setState({ cliente_sel: null, tipo_sel:null, vendedor_sel:null,fechaDesde: fechaDesde,
            fechaHasta: moment(this.props.fechaProceso, "DD/MM/YYYY")});
    }

    render(){
        return (
            <ContenedorForm porc_ancho={55}>
            <HeaderForm>
                <TituloForm>Artículos No Procesados</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <Row>
                        <ContainerCol className='col-sm-1' margen_arriba={20}>
                            <LabelForm>Desde:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2' margen_arriba={20}>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fecha)=>{this.setState({fechaDesde: fecha});}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-1' margen_arriba={20}>
                            <LabelForm>Hasta:</LabelForm>                        
                        </ContainerCol>
                        <ContainerCol className='col-sm-2' margen_arriba={20}>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fecha)=>{this.setState({fechaHasta: fecha});}}/>                        
                        </ContainerCol>
                    </Row> 
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-6'>
                            <LabelForm>Cliente:</LabelForm>
                                <ReactSelectAsync value={this.state.cliente_sel} func_loadOptions={this.getOptions_Clientes} func_onChange={(value)=>{this.setState({cliente_sel: value})}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-6'>
                            <LabelForm>Vendedor:</LabelForm>
                            <ReactSelect options={ this.state.vendedores } value={this.state.vendedor_sel} func_onChange={(value)=>{this.setState({vendedor_sel: value!==null?value:null})}}/>
                        </ContainerCol>    
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-6'>
                            <LabelForm>Marca:</LabelForm>
                            <ReactSelectAsync func_loadOptions={this.getOptions_Marcas} value={this.state.marca_sel} func_onChange={(value)=>{this.setState({marca_sel: value!==null?value:null})}}/>
                        </ContainerCol>    
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-6'>
                            <LabelForm>Pedido Móvil:</LabelForm>
                            <InputText autoComplete='off' name='pedidoMovil' value={this.state.pedidoMovil===undefined?'':this.state.pedidoMovil} type='text' className='form-control input-sm' placeholder='Ped.Móv.' onChange={this.handleInputChange}/>
                        </ContainerCol>
                    </Row>
                    {/* <Row>
                        <ContainerCol className='col-sm-6' margen_abajo='4'>
                            <LabelForm><input type='checkbox' name='resumido' checked={this.state.resumido} 
                            onChange={this.handleInputChange}/> Resumen</LabelForm>
                        </ContainerCol>                      
                    </Row> */}
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-info btn-sm' onClick={this.impRptArticulosNoDespachados}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
} 

const mapStateToProps = ((state) => {
    return { fechaProceso: state.sesion.valoresSesionForm.FechaProceso,tipoUsuario: state.sesion.valoresSesionForm.TipoUsuario }
});

const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm, cambiar_VisualizacionLoading}, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(FormVen24);